import { useEffect, useState } from 'react';
import { Input } from '@library/components/inputs';

export const SimulationRunNameInput = ({
  onValueChange,
  placeholder,
  value
}: {
  onValueChange: (newName: string) => void;
  placeholder: string;
  value: string;
}) => {
  const [simName, setSimName] = useState<string>(value);

  useEffect(() => {
    if ((simName && simName !== value) || (!simName && value !== '')) {
      onValueChange(simName);
    }
  }, [onValueChange, simName, value]);

  return (
    <Input
      labelName="Simulation Name"
      onValueChange={setSimName}
      placeholder={placeholder}
      value={simName}
    />
  );
};
